<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <!-- Main Content-->
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <!-- Page Header -->
                    <div class="page-header">
                        <div>
                            <h2 class="main-content-title tx-18 mg-b-5">
                                {{'header.subject-change.titleList.AllSubChRecords' | translate}}</h2>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item active">{{'header.subject-change.titleList.SubChData' |
                                    translate}}</li>
                            </ol>
                        </div>
                        <div class="d-flex">
                            <div class="justify-content-center">
                                <button type="button" class="btn btn-primary my-2 btn-icon-text floatright"
                                    (click)="addnewrecord('true')">
                                    {{'header.subject-change.titleList.AddNewRecord' | translate}}
                                </button>
                                <!-- <button type="button"
                                    class="btn btn-primary my-2 me-2  btn-icon-text floatright btn-default btn-lg" (click)="
                                        download()">
                                    <i class="fe fe-download-cloud me-2"></i> {{'header.subject-change.titleList.DownloadReport' | translate}}
                                </button>
                                <button mat-button [matMenuTriggerFor]="menu" type="button"
                                    class="btn btn-white btn-icon-text my-2 me-2 dropdown-toggle floatright"
                                    data-toggle="dropdown">
    
                                    <i class="fe fe-filter me-2"></i> Doc Type
    
                                </button>
                                <mat-menu #menu="matMenu">
                                    <mat-option value="Yes">.csv </mat-option>
                                    <mat-option value="No">pdf</mat-option>
                                </mat-menu> -->
                            </div>
                        </div>
                    </div>
                    <!-- list of faculty start  -->

                    <!-- list of faculty end  -->
                    <!-- add of faculty start  -->
                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="SubChgForm">
                            <div class="col-lg-12 col-md-12">

                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div *ngIf="submitButton" class="mb-3">
                                            <h3 class="main-content-label mb-1">
                                                <b>{{'header.subject-change.titleList.AddNewSubChRecord' |
                                                    translate}}</b>
                                            </h3>
                                            <p class="text-muted card-sub-title mb-0">
                                                {{'header.subject-change.titleList.AddNewSubChInformation' |
                                                translate}}</p>
                                        </div>
                                        <div *ngIf="editButton" class="mb-3">
                                            <h3 class="main-content-label mb-1">
                                                <b>{{'header.subject-change.titleList.UpdateSubChRecord' |
                                                    translate}}</b>
                                            </h3>
                                            <p class="text-muted card-sub-title mb-0 ">
                                                {{'header.subject-change.titleList.UpdateSelectedSubChInformation'
                                                |
                                                translate}}
                                            </p>
                                        </div>
                                        <div *ngIf="deleteButton" class="mb-3">
                                            <h3 class="main-content-label mb-1">
                                                <b>{{'header.subject-change.titleList.DeleteSubChRecord' |
                                                    translate}}</b>
                                            </h3>
                                            <p class="text-muted card-sub-title mb-0 ">
                                                {{'header.subject-change.titleList.DeleteSelectedSubChInformation'
                                                |
                                                translate}}
                                            </p>
                                        </div>
                                        <div class="row clearfix mt-3">
                                            <div class="col-sm-6">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> {{'header.subject-change.titleList.ListNo' |
                                                            translate}}</mat-label>
                                                        <!-- <input matInput formControlName="" placeholder="Exam" > -->
                                                        <mat-select formControlName="SubChglistNo" #select23
                                                            class="colorblack">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'"
                                                                [displayMember]="'item.ListDesc'" [array]="DataList"
                                                                (filteredReturn)=" filteredDataList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of  filteredDataList"
                                                                [value]="item.EcId">
                                                                {{item.ListDesc}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> </mat-label>
                                                        <input matInput formControlName="SubChglistNo2" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-4">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label> </mat-label>
                                                        <input matInput formControlName="SubChglistNo3" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-2">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>{{'header.subject-change.titleList.Colg' |
                                                            translate}}</mat-label>
                                                        <input matInput formControlName="SubChgClg" placeholder="">
                                                    </mat-form-field>
                                                </div>
                                            </div>

                                            <div class="col-sm-3 mt-1">
                                                <div class="form-group">
                                                    <div class="row">
                                                        <div class="col-sm-3 mt-3">
                                                            <mat-label class="mt-1 lclass"><span
                                                                    class="required-asterisk mr-1"></span>{{'header.subject-change.titleList.Valid'
                                                                | translate}}</mat-label>
                                                        </div>
                                                        <div class="col-sm-7 mt-1">
                                                            <mat-radio-group formControlName="SubChgValid"
                                                                class="example-full-width">
                                                                <div class="row">
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='Y'>Yes</mat-radio-button>
                                                                    </div>
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='N'>No</mat-radio-button>
                                                                    </div>
                                                                </div>
                                                            </mat-radio-group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-3 mt-1">
                                                <div class="form-group">
                                                    <div class="row">
                                                        <div class="col-sm-4 mt-3">
                                                            <mat-label class="mt-1 lclass"><span
                                                                    class="required-asterisk mr-1"></span>{{'header.subject-change.titleList.Change'
                                                                | translate}}</mat-label>
                                                        </div>
                                                        <div class="col-sm-7 mt-1">
                                                            <mat-radio-group formControlName="SubChgChng"
                                                                class="example-full-width">
                                                                <div class="row">
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='Y'>Yes</mat-radio-button>
                                                                    </div>
                                                                    <div class="col-sm-4 p-1 mt-2">
                                                                        <mat-radio-button
                                                                            value='N'>No</mat-radio-button>
                                                                    </div>
                                                                </div>
                                                            </mat-radio-group>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="row clearfix">
                                            <div class="col-sm-6 margindotted">
                                                <div class="row clearfix">
                                                    <div class="col-sm-6">
                                                        <div class="form-group">
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label>{{'header.subject-change.titleList.Batch' |
                                                                    translate}}</mat-label>
                                                                <input matInput formControlName="SubChgBatch"
                                                                    placeholder="">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>


                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-sm-6">
                                                        <div class="form-group">
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label>{{'header.subject-change.titleList.RollNo' |
                                                                    translate}}</mat-label>
                                                                <input matInput formControlName="SubChgRollNo"
                                                                    placeholder="">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>


                                                </div>
                                                <div class="row clearfix">
                                                    <div class="col-sm-10">
                                                        <div class="form-group">
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label>{{'header.subject-change.titleList.Name' |
                                                                    translate}}</mat-label>
                                                                <input matInput formControlName="SubChgName"
                                                                    placeholder="">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>


                                                </div>
                                                <div class="row clearfix">

                                                    <div class="col-sm-2">
                                                        <div class="form-group">
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label>{{'header.subject-change.titleList.Valid' |
                                                                    translate}}</mat-label>
                                                                <input matInput formControlName="SubChgValid2"
                                                                    placeholder="">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-8">
                                                        <div class="form-group">
                                                            <mat-form-field appearance="outline"
                                                                class="example-full-width">
                                                                <mat-label> </mat-label>
                                                                <input matInput formControlName="SubChgValid3"
                                                                    placeholder="">
                                                            </mat-form-field>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-6">
                                                <p class="main-content-label f10">
                                                    Table
                                                </p>
                                                <div>
                                                    <table id="datatable" class="table text-nowrap table-bordered text-left">
                                                        <thead>
                                                            <tr >
                                                                <th class="f600">
                                                                </th>
                                                                <th class="f600">
                                                                </th>
                                                                <th class="f600">
                                                                </th>
                                                               
                                                            </tr>
                                                        </thead>
                                                        <tbody id="table_data" >
                                                            <tr >
                                                                <td>
                                                                    <input class="form-control input-sm">
                                                                </td>
                                                                <td>
                                                                    <input class="form-control input-sm">
                                                                </td>
                                                                <td>
                                                                    <input class="form-control input-sm">
                                                                </td>
                                                                
                                                               
                                                            </tr>
                                                            <tr >
                                                                <td>
                                                                   <input class="form-control input-sm">
                                                                </td>
                                                                <td>
                                                                   <input class="form-control input-sm">
                                                                </td>
                                                                <td>
                                                                   <input class="form-control input-sm">
                                                                </td>
                                                                
                                                               
                                                            </tr>
                                                            <tr >
                                                                <td>
                                                                   <input class="form-control input-sm">
                                                                </td>
                                                                <td>
                                                                   <input class="form-control input-sm">
                                                                </td>
                                                                <td>
                                                                   <input class="form-control input-sm">
                                                                </td>
                                                                
                                                                
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-12">
                                            <button type="button"
                                                class="btn btn-primary my-2 me-2 mt-0 btn-icon-text floatright btn-raised g-bg-blush2"
                                                *ngIf="submitButton"
                                                (click)="submit()">{{'header.subject-change.titleList.Submit' |
                                                translate}}</button>
                                            <button type="button"
                                                class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                *ngIf="editButton"
                                                (click)="update()">{{'header.subject-change.titleList.Update' |
                                                translate}}</button>
                                            <button type="button"
                                                class="btn btn-primary my-2 me-2 btn-icon-text floatright btn-raised g-bg-blush2"
                                                *ngIf="deleteButton"
                                                (click)="delete()">{{'header.subject-change.titleList.Delete' |
                                                translate}}</button>
                                            <button type="button"
                                                class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                                (click)="addnewrecord('false')">{{'header.subject-change.titleList.Back'
                                                |
                                                translate}}</button>
                                        </div>

                                        <div class="table-responsive">
                                            <table id="datatable" class="table table-bordered text-nowrap text-left">
                                                <thead>
                                                    <tr>
                                                        <th class="f600">
                                                            {{'header.subject-change.table.SubChRg'| translate}}
                                                        </th>
                                                        <th class="f600">
                                                             {{'header.subject-change.table.Batch' | translate}}
                                                        </th>
                                                        <th class="f600">
                                                            {{'header.subject-change.table.RollNo' | translate}}
                                                        </th>
                                                        <th class="f600">
                                                            {{'header.subject-change.table.Name' | translate}}
                                                        </th>
                                                        <th class="f600">
                                                            {{'header.subject-change.table.RegnNo' | translate}}
                                                        </th>
                                                        <th class="f600">
                                                            {{'header.subject-change.table.Colg' | translate}}
                                                        </th>
                                                        <th class="f600">
                                                            {{'header.subject-change.table.Valid' | translate}}
                                                        </th>
                                                        <th class="f600">
                                                            {{'header.subject-change.table.Change' | translate}}
                                                        </th>
                                                        <th class="f600">
                                                             {{'header.subject-change.table.Message' | translate}}
                                                        </th>
                                                        <th class="f600" class="f600 text-center">
                                                            {{'header.subject-change.table.Action' | translate}}
                                                        </th>
                                                        
                                                    </tr>
                                                </thead>
                                                <tbody id="table_data">
                                                    <tr >
                                                        <td>
                                                            
                                                        </td>
                                                        <td>
                                                            
                                                        </td>
                                                        <td >
        
                                                            
                                                        </td>
                                                        <td>
                                                            
                                                        </td>
                                                        <td>
                                                            
                                                        </td>
                                                        <td >
        
                                                            
                                                        </td>
                                                        <td>
                                                            
                                                        </td>
                                                        <td>
                                                            
                                                        </td>
                                                        <td >
        
                                                            
                                                        </td>
                                                        <td class="text-center">

                                                            <a class="btn-floating" title="Edit"
                                                                (click)="edit('true','faculty')">
                                                               
                                                                <i class="fa fa-edit"></i>
                                                            </a>
                                                            <a class="btn-floating" title="Delete"
                                                                (click)="deletee('true','faculty')">
                                                                
                                                                <i class="fas fa-trash"></i>
                                                            </a>
                                                        </td>
                                                        
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>